export default __webpack_public_path__ + "static/media/NEO NX 110_3.43c06fcf.webp";